<template>
  <quest-main
    title="Proof points"
    copy="Management of catchy and noteworthy marketing material"
    :loading="loading"
  >
    <template v-slot:head>
      <router-link
        :to="{ name: 'proof-points-add' }"
        class="d-sm-inline-block btn btn-sm btn-primary shadow-sm"
      >
        <font-awesome-icon
          icon="plus"
          size="sm"
          class="text-white-50"
        ></font-awesome-icon>
        Add</router-link
      >
    </template>
    <template v-slot:body>
      <quest-card title="Proof point collection">
        <quest-table id="points-table" :columns="columns">
          <template v-if="points.items.length > 0">
            <tr
              class="small align-middle"
              v-for="point in points.items"
              :key="point.id"
            >
              <td>
                <router-link
                  :to="{
                    name: 'proof-points-edit',
                    params: { id: point.id },
                  }"
                  >{{ point.name || '(untitled)' }}</router-link
                >
              </td>
              <td>{{ lastModified(point.modifiedUTC) }}</td>
              <td>
                <b-dropdown no-caret variant="link">
                  <template #button-content>
                    <font-awesome-icon
                      icon="ellipsis-v"
                      size="sm"
                      fixed-width
                      class="text-gray-400"
                    ></font-awesome-icon>
                  </template>
                  <b-dropdown-header>Actions</b-dropdown-header>
                  <b-dropdown-item
                    :to="{
                      name: 'proof-points-edit',
                      params: { id: point.id },
                    }"
                    >View</b-dropdown-item
                  >
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                    @click="promptDelete(point)"
                    text="danger"
                    variant="danger"
                    >Delete</b-dropdown-item-button
                  >
                </b-dropdown>
              </td>
            </tr>
          </template>
          <template v-if="points.items.length === 0">
            <tr class="align-middle">
              <td :colspan="columns.length">
                <div class="small text-center py-5">
                  There are no proof points in the system
                </div>
              </td>
            </tr>
          </template>
        </quest-table>
        <quest-pager
          v-if="points.total > pageSize"
          @changePage="changePage"
          :currentPage="page"
          :itemCount="points.total"
          :pageSize="pageSize"
        ></quest-pager>
      </quest-card>
      <b-modal v-model="showModal" centered title="Delete">
        <p class="my-4">
          Are you sure you wish to delete proof point '{{
            toDelete ? toDelete.name || 'untitled' : 'untitled'
          }}'?
        </p>
        <template v-slot:modal-footer>
          <button
            class="btn btn-secondary btn-sm"
            type="button"
            @click="cancelPromptDelete"
          >
            Cancel</button
          ><button
            class="btn btn-danger btn-sm"
            type="button"
            @click="confirmPromptDelete"
          >
            Delete
          </button>
        </template>
      </b-modal>
    </template>
  </quest-main>
</template>

<script>
import { success, error } from '../helpers'
import moment from 'moment'
import 'moment-timezone'
import {
  QuestMain,
  QuestTable,
  QuestCard,
  QuestModal,
  QuestPager,
} from './structure'
import { ProofPointService } from '../services'
import PagedResult from '../models/paged-result'

export default {
  name: 'themes',
  components: {
    QuestMain,
    QuestTable,
    QuestCard,
    QuestPager,
    QuestModal,
  },
  data() {
    return {
      pageSize: 10,
      page: 1,
      term: '',
      points: new PagedResult(),
      columns: ['Name', 'Modified', ''],
      toDelete: null,
      showModal: false,
      loading: true,
    }
  },
  mounted() {
    this.changePage(1)
  },
  methods: {
    lastModified(date) {
      return moment(`${date}Z`).tz('Australia/Melbourne').format('lll')
    },
    changePage(page) {
      new ProofPointService()
        .list(page, this.pageSize, this.term)
        .then((data) => {
          this.points = data
          this.page = page
        })
        .finally((_) => (this.loading = false))
    },
    promptDelete(theme) {
      this.toDelete = theme
      this.showModal = true
    },
    cancelPromptDelete() {
      this.showModal = false
      this.toDelete = null
    },
    confirmPromptDelete() {
      new ProofPointService()
        .delete(this.toDelete.id)
        .then((data) => {
          this.showModal = false

          if (data) {
            this.changePage(1)
            success(`Deleted proof point #`, this.toDelete.name)
          } else {
            error(`Failed to delete proof point #`, this.toDelete.name)
          }
        })
        .finally((_) => (this.toDelete = null))
    },
  },
}
</script>
